import crypto from 'crypto';
import { capitalizeFirstLetter } from './text';
import {
  getCookieWckAuthData,
  getCookieWckDisplayFrontLocation,
  getCookieWckDisplayMktSID,
} from './cookie';
import { isEmpty } from './baseUtils';

// PC 도메인 연결.
export const addAsIsPcWebDomain = async (path: string) => {
  if (path.indexOf('http://') > -1 || path.indexOf('https://') > -1) {
    return path;
  }

  const isLocal = process.env.NEXT_PUBLIC_MODE === 'local';
  const isDev = process.env.NEXT_PUBLIC_MODE === 'dev';
  const isStage = process.env.NEXT_PUBLIC_MODE === 'stage';

  // 개발 서버일때 AS-IS에서 세팅해준 도메인정보를 확인해서 URL 처리.
  if (isLocal || isDev || isStage) {
    const domain = await getCookieWckDisplayFrontLocation();
    if (!isEmpty(domain)) {
      return `${domain}${path}`;
    }
  }
  return `${process.env.NEXT_PUBLIC_AS_IS_WCONCEPT_PC_WEB || ''}${path}`;
};

// MWEB 도메인 연결.
export const addAsIsMWebDomain = async (path: string) => {
  if (path.indexOf('http://') > -1 || path.indexOf('https://') > -1) {
    return path;
  }

  const isLocal = process.env.NEXT_PUBLIC_MODE === 'local';
  const isDev = process.env.NEXT_PUBLIC_MODE === 'dev';
  const isStage = process.env.NEXT_PUBLIC_MODE === 'stage';

  // 개발 서버일때 AS-IS에서 세팅해준 도메인정보를 확인해서 URL 처리.
  if (isLocal || isDev || isStage) {
    const domain = await getCookieWckDisplayFrontLocation();
    if (!isEmpty(domain)) {
      return `${domain}${path}`;
    }
  }
  return `${process.env.NEXT_PUBLIC_AS_IS_WCONCEPT_MOBILE_WEB || ''}${path}`;
};

// MWEB의 Target URL.
export const getMWebTargetUrl = (webViewUrl: string, newTargetUrl: string) => {
  //
  if (isEmpty(newTargetUrl)) {
    return addAsIsMWebDomain(webViewUrl);
  }
  return newTargetUrl;
};

// 현재 URL.
type CurrentUrlOptions = {
  readonly isAddTimestamp?: boolean;
};

export const currentUrl = ({
  isAddTimestamp = false,
}: CurrentUrlOptions = {}) => {
  const href =
    typeof window !== 'undefined' && window.location.href
      ? window.location.href
      : '';
  if (!href) {
    return '';
  }

  if (isAddTimestamp) {
    const timestamp = new Date().getTime();
    const url = new URL(href);
    url.searchParams.set('timestamp', timestamp.toString());
    return url.toString();
  }
  return href;
};

// Resize Image URL.
export const getResizeImageUrl = (imageUrl?: string, rs?: string) => {
  if (isEmpty(imageUrl)) {
    return '';
  }
  if (!isEmpty(rs) && imageUrl && rs) {
    return `${imageUrl}?RS=${rs}`;
  }
  return imageUrl;
};

export const getReferer = (url?: string) => {
  try {
    if (url) {
      return new URL(url)?.pathname
        ?.substring(1)
        ?.split('/')
        .map(str => capitalizeFirstLetter(str))
        .join('/');
    }
    return 'HOME';
  } catch (e) {
    console.log(e);
    return 'HOME';
  }
};

export const getMolocoCustNo = async (
  isAmplitude: boolean,
  userCustNo?: string
) => {
  const auth = await getCookieWckAuthData();
  const custNo = userCustNo || auth.userNo;
  if (isAmplitude) {
    if (custNo === '0' || custNo === '') {
      return getCookieWckDisplayMktSID();
    }
    return crypto.createHash('sha256').update(`W${custNo}`).digest('hex');
  }
  if (custNo === '0' || custNo === '') {
    return '';
  }
  return crypto.createHash('sha256').update(`W${custNo}`).digest('hex');
};

// MWEB의 newTargetUrl 전시 기획전 분기.
export const getNewTargetUrl = (newTargetUrl: string) => {
  // 전시 도메인 제외는 newTargetUrl fullurl로 내려옴
  if (
    newTargetUrl.indexOf('http://') > -1 ||
    newTargetUrl.indexOf('https://') > -1
  ) {
    return newTargetUrl;
  }

  return `${process.env.NEXT_PUBLIC_WCONCEPT_DISPLAY_WEB || ''}${newTargetUrl}`;
};
